import React from 'react';
import { useTheme } from '@material-ui/core';
import { SupervisorAccountOutlined } from '@material-ui/icons';

import StatusChip from './StatusChip';

export const SMAChip = () => {
  const theme = useTheme();

  return <StatusChip
    themeColor={theme.palette.lightBlue}
    tooltipText="components.login.tooltips.sso"
    label="components.login.chip.sso"
    icon={SupervisorAccountOutlined}
  />
}
